'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');

module.exports = function FileContextDispatcher(config, pageController, navigatorShim, fileSession) {
	if (!config || !pageController || !navigatorShim) {
		throw new Error('invalid-args');
	}
	const self = observable(this),
		publishMeta = function () {
			return fileSession.getFileContext()
			.then(context => {
				if (context && context.title) {
					self.dispatchEvent('title', context.title);
				}
				if (context) {
					self.dispatchEvent('fileContext', context);
				}
			})
			.catch((e) => {
				self.dispatchEvent('fail', e);
			});
		};
	pageController.addEventListener('fileLoaded', function (fileId, title, context) {
		if (context) {
			self.dispatchEvent('fileContext', context);
		}

		if (fileSession) {
			navigatorShim.setInterval(publishMeta, config.metaDataSyncPeriod || 60000);
		}
	});
	pageController.addEventListener('saveFileSuccess fileMerged filePropertiesChanged', function (context) {
		if (context) {
			self.dispatchEvent('fileContext', context);
		}
	});
};
